(() => {
  const paper = window.DirtPaper ||= {};
  if (paper.consentRecoveryInitialized) return;
  paper.consentRecoveryInitialized = true;
  const keys = ['marketing', 'analytics', 'preferences'];
  const controls = {
    'shopify-pc__banner__btn-accept': true,
    'shopify-pc__banner__btn-decline': false,
    'shopify-pc__prefs__header-accept': true,
    'shopify-pc__prefs__header-decline': false,
    'shopify-pc__prefs__header-save': null
  };
  let observer, notice, attempt;
  const element = id => document.getElementById(id);
  const shown = node => node && node.isConnected && getComputedStyle(node).display !== 'none';
  function confirmed(choice) {
    try {
      const consent = window.Shopify.customerPrivacy.currentVisitorConsent();
      return keys.every(key => consent[key] === (choice[key] ? 'yes' : 'no'));
    } catch {return false;}
  }
  function clear() {
    observer?.disconnect();
    observer = null;
    notice?.remove();
    notice = null;
    attempt = null;
  }
  function recover(current) {
    const box = document.createElement('div');
    box.setAttribute('data-dirt-consent-recovery', '');
    box.setAttribute('role', 'alert');
    box.tabIndex = -1;
    const message = document.createElement('p');
    message.textContent = 'Je cookiekeuze is niet bevestigd. Probeer het opnieuw.';
    const retry = document.createElement('button');
    retry.type = 'button';
    retry.textContent = 'Cookiekeuze opnieuw openen';
    box.append(message, retry);
    notice = box;
    document.body.append(box);
    box.focus({preventScroll: true});
    retry.addEventListener('click', async () => {
      if (retry.disabled) return;
      retry.disabled = true;
      try {
        const rootId = current.preferences ? 'shopify-pc__prefs' : 'shopify-pc__banner';
        const previousRoot = element(rootId);
        function opened() {
          if (attempt !== current) return;
          const root = element(rootId);
          if (root === previousRoot || !shown(root)) return;
          if (current.preferences) {
            const inputs = keys.map(key => element(`shopify-pc__prefs__${key}-input`));
            if (inputs.some(input => !input)) return;
            inputs.forEach((input, index) => {
              input.checked = current.choice[keys[index]];
              input.dispatchEvent(new Event('change', {bubbles: true}));
            });
          } else {
            element('shopify-pc__banner__btn-manage-prefs')?.focus({preventScroll: true});
          }
          clear();
        }
        observer?.disconnect();
        // The provider promise resolves before its asynchronous DOM render finishes.
        observer = new MutationObserver(opened);
        observer.observe(document.body, {childList: true, subtree: true});
        const api = window.privacyBanner;
        await api[current.preferences ? 'showPreferences' : 'showBanner']();
        opened();
      } catch {
        if (attempt === current) message.textContent = 'Je cookiekeuze kon niet worden geopend. Probeer het opnieuw.';
      } finally {retry.disabled = false;}
    });
  }
  document.addEventListener('click', event => {
    const button = event.target.closest?.('button');
    if (!button) return;
    if (button.id === 'shopify-pc__prefs__header-close') {clear(); return;}
    if (!Object.hasOwn(controls, button.id)) return;
    if (window.Shopify?.designMode || new URLSearchParams(location.search).get('preview_privacy_banner') === '1') return;
    const preferences = button.id.startsWith('shopify-pc__prefs__');
    const root = element(preferences ? 'shopify-pc__prefs' : 'shopify-pc__banner');
    if (!shown(root) || !root.contains(button)) return;
    const choice = {};
    for (const key of keys) {
      const input = element(`shopify-pc__prefs__${key}-input`);
      if (controls[button.id] === null && !input) return;
      choice[key] = controls[button.id] === null ? input.checked : controls[button.id];
    }
    clear();
    const current = attempt = {choice, preferences};
    // Shopify updates consent before hiding on success, but also hides on API errors.
    observer = new MutationObserver(() => {
      if (shown(root)) return;
      observer?.disconnect();
      observer = null;
      if (confirmed(choice)) clear();
      else recover(current);
    });
    observer.observe(root, {attributes: true, attributeFilter: ['style']});
  }, true);
  document.addEventListener('keydown', event => {
    if (event.key === 'Escape' && attempt?.preferences && shown(element('shopify-pc__prefs'))) clear();
  }, true);
  document.addEventListener('visitorConsentCollected', () => {
    if (attempt && confirmed(attempt.choice)) clear();
  });
})();
